<template>
  <div
    v-if="options"
    class="page-length-selector"
  >
    <span
      id="page-length-label"
      class="page-length-selector__label"
    >
      Produkte pro Seite:
    </span>
    <ListDropdown
      class="page-length-selector__dropdown"
      :value="currentPageLength.toString()"
      :options="options"
      :label="ariaLabel"
      aria-labelledby="page-length-label"
      aria-describedby="page-length-description"
      @select="onSelect"
    />
    <span
      id="page-length-description"
      class="sr-only"
    >
      Wählen Sie, wie viele Produkte pro Seite angezeigt werden sollen. Aktuelle Auswahl:
      {{ currentPageLength }} Produkte.
    </span>
  </div>
</template>

<script setup lang="ts">
import { withDefaults, computed } from 'vue';
import type { FilterOption } from '@i22/td-longtail-vue-components/dist/components/dropdown/list-dropdown-helper';
import { ListDropdown } from '@i22/td-longtail-vue-components';

type PageLengthSelectorProps = {
  currentPageLength: number;
  pageLengths?: number[];
  promotedOfferSpace?: number;
};

const props = withDefaults(defineProps<PageLengthSelectorProps>(), {
  promotedOfferSpace: 0,
  pageLengths: () => [48, 98],
});

const emit = defineEmits<{
  (e: 'change', value: string): void;
}>();

const ariaLabel = computed(
  () => `Anzahl der Produkte pro Seite ändern. Aktuell: ${props.currentPageLength} Produkte.`
);

const options = computed<FilterOption[] | undefined>(() => {
  if (!props.pageLengths) return undefined;
  return props.pageLengths.map((pageLength) => {
    const size = pageLength - props.promotedOfferSpace;
    return {
      value: size.toString(),
      label: size.toString(),
    };
  });
});

const onSelect = (pageLength: string) => {
  emit('change', pageLength);
};

defineExpose({
  options,
});
</script>

<style lang="scss" scoped>
.page-length-selector {
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &__label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    white-space: nowrap;
  }

  &__dropdown {
    :deep(.dropdown-container) {
      width: 180px;
    }
  }
}
</style>
